import {
    PluginClass,
    PluginConfig,
} from '@src/slide/application/no-edit/service/no-edit-service/no-edit-service.interface';

export const FILE_INFO_PLUGIN_CONFIG: PluginConfig = {
    name: 'no-edit-file-info',
    plugin: async () => {
        // @ts-ignore
        const module: { default: PluginClass } = await import(/* webpackChunkName: "service" */'./file-info-plugin');
        return module.default;
    },
};
